<template>
    <div
        ref="slider"
        class="relative w-64 xl:w-80 pb-8 flickity-slider__card-flick flickity-slider__active-forward flickity-slider__overflow"
    >
        <slot />
    </div>
</template>

<script>
import Flickity from 'flickity';

export default {
    data() {
        return {
            flickity: null
        };
    },

    mounted() {
        if (this.$refs.slider) {
            this.flickity = new Flickity(this.$refs.slider, {
                cellAlign: 'left',
                prevNextButtons: false,
                selectedAttraction: 0.01,
                friction: 0.15
            });
        }

        ScrollTrigger.refresh();
    }
};
</script>
